export class Bank {
    id: number = 0;
    description: string = "";
    corporateName: string = "";
    cnpj: string = "";
    address: string = "";
    member: string = "";
    endDate: string = "";
    dueDate: number = 0;
}

